<template>
  <div>
    <div class="d-flex justify-space-between mb-5">
      <div>
        <div class="page-title mb-2">รายการแจ้งลบกระทู้</div>
        <div class="theme-color-eight">รายการยื่นขอลบกระทู้</div>
      </div>

      <div style="max-width: 280px">
        <TextField
          :value="keyword"
          hide-details
          placeholder="ค้นหา"
          append-icon="ic:baseline-search"
          @onChange="keyword = $event"
          @onEnter="onSearch"
        />
      </div>
    </div>

    <div class="mt-8">
      <div class="d-flex justify-space-between table-head">
        <div
          v-for="(col, i) in tableHeader"
          :key="i"
          :style="{ width: col.width }"
        >
          {{ col.name }}
        </div>
      </div>

      <div class="list-layout">
        <RowCard
          v-for="(request, index) in requests"
          :key="request.id"
          class="request-row-card align-start py-4"
          @click.native="openTopic(request.topicId)"
        >
          <div
            :style="{ width: tableHeader[0].width }"
            class="request-cell request-cell-number"
          >
            {{ getRowNumber(index) }}
          </div>

          <div
            :style="{ width: tableHeader[1].width }"
            class="request-cell request-cell-date"
            style="white-space: nowrap"
          >
            {{ request.postDateText }}
          </div>

          <div :style="{ width: tableHeader[2].width }">
            <div class="request-title-row">
              <div class="request-title">{{ request.title }}</div>
              <span v-if="request.isSelfRequested" class="owner-delete-tag">
                เจ้าของกระทู้แจ้งลบเอง
              </span>
            </div>
          </div>

          <div
            :style="{ width: tableHeader[3].width }"
            class="request-cell request-cell-author"
          >
            {{ request.author }}
          </div>

          <div
            :style="{ width: tableHeader[4].width }"
            class="request-cell request-cell-views text-center"
          >
            {{ request.view_count }}
          </div>

          <div :style="{ width: tableHeader[5].width }" class="request-row-actions">
            <button
              class="details-button"
              type="button"
              @click.stop="openTopic(request.topicId)"
            >
              รายละเอียดกระทู้
            </button>
            <button
              class="review-button review-button-reject"
              type="button"
              @click.stop="openReviewDialog(request, 'rejected')"
            >
              <Iconify icon="mdi:close-thick" color="#FFFFFF" size="14px" />
              <span>ไม่ลบ</span>
            </button>
            <button
              class="review-button review-button-approve"
              type="button"
              @click.stop="openReviewDialog(request, 'approved')"
            >
              <Iconify
                icon="fluent:calendar-cancel-20-regular"
                color="#FFFFFF"
                size="15px"
              />
              <span>ลบกระทู้</span>
            </button>
          </div>
        </RowCard>

        <div v-if="!requests.length" class="empty-state">
          ไม่พบคำขอลบกระทู้
        </div>
      </div>
    </div>

    <div class="d-flex justify-center mt-8 mb-4">
      <v-pagination
        v-model="paginate.current_page"
        :length="paginate.last_page"
        color="#DE7033"
        :total-visible="7"
        @input="getTopics"
      />
    </div>

    <v-dialog v-model="reviewDialog" max-width="540" persistent>
      <div class="review-modal">
        <button class="review-close-button" type="button" @click="closeReviewDialog">
          <Iconify icon="mdi:close" color="var(--theme-color-eight)" size="24px" />
        </button>

        <div class="review-icon-wrap">
          <Iconify
            icon="mdi:forum-remove"
            color="var(--theme-color-seven)"
            size="60px"
          />
        </div>

        <div class="review-title">{{ reviewDialogTitle }}</div>
        <div class="review-subtitle">
          {{ reviewDialogSubtitle }}
          <span class="review-topic-name">"{{ selectedRequest?.title || "-" }}"</span>
        </div>

        <div class="review-field-label">เหตุผลในการพิจารณา</div>

        <TextArea
          :value="reviewReason"
          :disabled="reviewLoading"
          hide-details
          theme="3"
          autogrow
          height="110"
          placeholder="ระบุเหตุผล"
          @onChange="reviewReason = $event"
        />

        <div class="review-reason-preview mt-4">
          <div class="review-reason-label">เหตุผลที่ผู้ใช้แจ้งลบ</div>
          <div class="review-reason-text">{{ selectedRequest?.deleteReason || "-" }}</div>
        </div>

        <div class="review-actions mt-6">
          <button
            class="review-action-button"
            type="button"
            :disabled="reviewLoading"
            @click="closeReviewDialog"
          >
            ยกเลิก
          </button>
          <button
            class="review-action-button"
            :class="reviewDialogMode === 'approved' ? 'review-action-approve' : 'review-action-reject'"
            type="button"
            :disabled="reviewLoading"
            @click="submitReview(reviewDialogMode)"
          >
            {{ reviewDialogConfirmText }}
          </button>
        </div>
      </div>
    </v-dialog>
  </div>
</template>

<script>
import TextArea from "@/components/input/TextArea.vue";
import TextField from "@/components/input/TextField.vue";
import RowCard from "@/components/RowCard.vue";

export default {
  name: "WebboardDeleteRequests",
  components: {
    TextArea,
    TextField,
    RowCard,
  },
  data() {
    return {
      keyword: "",
      requests: [],
      tableHeader: [
        { name: "ลำดับ",            width: "5%"  },
        { name: "วันที่โพสต์",      width: "12%" },
        { name: "หัวข้อ",           width: "29%" },
        { name: "ผู้โพสต์",         width: "10%" },
        { name: "จำนวนผู้มองเห็น",  width: "8%"  },
        { name: "",                 width: "30%" },
      ],
      reviewDialog: false,
      reviewDialogMode: "approved",
      selectedRequest: null,
      reviewReason: "",
      reviewLoading: false,
      paginate: {
        total: 0,
        per_page: 10,
        current_page: 1,
        last_page: 1,
      },
    };
  },
  created() {
    this.getTopics();
  },
  computed: {
    reviewDialogTitle() {
      return this.reviewDialogMode === "approved" ? "ลบกระทู้" : "ไม่ลบกระทู้";
    },
    reviewDialogSubtitle() {
      return this.reviewDialogMode === "approved"
        ? "ยืนยันการลบกระทู้ โดยสามารถระบุเหตุผลในการดำเนินการได้"
        : "ยืนยันว่าไม่ลบกระทู้ โดยสามารถระบุเหตุผลในการพิจารณาได้";
    },
    reviewDialogConfirmText() {
      return this.reviewDialogMode === "approved" ? "ยืนยันลบ" : "ยืนยันไม่ลบ";
    },
  },
  methods: {
    formatThaiDate(date, withTime = false) {
      if (!date) return "-";

      const monthNames = [
        "มกราคม",
        "กุมภาพันธ์",
        "มีนาคม",
        "เมษายน",
        "พฤษภาคม",
        "มิถุนายน",
        "กรกฎาคม",
        "สิงหาคม",
        "กันยายน",
        "ตุลาคม",
        "พฤศจิกายน",
        "ธันวาคม",
      ];

      const momentDate = this.$moment(date);
      const day = momentDate.format("DD");
      const month = monthNames[momentDate.month()];
      const year = momentDate.year() + 543;

      if (!withTime) {
        return `${day} ${month} ${year}`;
      }

      return `${day} ${month} ${year} ${momentDate.format("HH:mm")}`;
    },
    async getTopics(page) {
      const res = await this.$apiFire("Webboard/deleteRequests", {
        keyword: this.keyword,
        page: page || this.paginate.current_page,
        per_page: this.paginate.per_page,
      });

      if (!res || !res.data) return;

      const topicResponse = res.data || {};

      this.requests = (topicResponse.data || []).map((request) => ({
        id: request.id,
        topicId: request?.topic?.id,
        title: request?.topic?.title || "-",
        author:
          request?.topic?.user?.name ||
          [request?.topic?.user?.firstname, request?.topic?.user?.lastname].filter(Boolean).join(" ") ||
          "-",
        requestedBy:
          request?.user?.name ||
          [request?.user?.firstname, request?.user?.lastname].filter(Boolean).join(" ") ||
          "ผู้ใช้ระบบ",
        isSelfRequested:
          Number(request?.user?.id || 0) === Number(request?.topic?.user?.id || -1),
        requestedAtText: this.formatThaiDate(request?.updated_at || request?.created_at, true),
        postDateText: this.formatThaiDate(request?.topic?.created_at),
        deleteReason: request?.reason,
        view_count: request?.topic?.view_count || 0,
        comments_count: request?.topic_comments_count || 0,
      }));

      this.paginate = {
        total: topicResponse.total || 0,
        per_page: topicResponse.per_page || 10,
        current_page: topicResponse.current_page || 1,
        last_page: topicResponse.last_page || 1,
      };
    },
    onSearch() {
      this.paginate.current_page = 1;
      this.getTopics(1);
    },
    getRowNumber(index) {
      return (this.paginate.current_page - 1) * this.paginate.per_page + index + 1;
    },
    openReviewDialog(request, mode) {
      this.selectedRequest = request;
      this.reviewDialogMode = mode || "approved";
      this.reviewReason = "";
      this.reviewDialog = true;
    },
    closeReviewDialog() {
      if (this.reviewLoading) return;
      this.reviewDialog = false;
      this.selectedRequest = null;
      this.reviewReason = "";
    },
    async submitReview(decision) {
      const reason = (this.reviewReason || "").trim();

      if (!this.selectedRequest) {
        this.$store.commit("General/setModal", {
          title: "ข้อมูลไม่ถูกต้อง",
          text: "ไม่พบคำขอที่ต้องการทำรายการ",
          buttonText: "ตกลง",
          showCancel: false,
          theme: "warning",
        });
        return;
      }

      this.reviewLoading = true;
      const res = await this.$apiFire("Webboard/reviewDeleteRequest", {
        id: this.selectedRequest.id,
        decision,
        reason,
      });
      this.reviewLoading = false;

      if (!res) return;

      this.closeReviewDialog();
      await this.getTopics(this.paginate.current_page);
    },
    openTopic(id) {
      this.$router.push({ name: "WebboardDetail", params: { id } });
    },
  },
};
</script>

<style scoped lang="scss">
.table-head {
  padding: 0 33px 0 36px;
  margin-bottom: 12px;
  gap: 8px;
  color: var(--theme-color-two);
  font-size: 13px;
}

.list-layout {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.request-row-card {
  cursor: pointer;
}

.request-cell {
  color: var(--theme-color-two);
  font-size: 14px;
  line-height: 1.5;
  font-family: var(--font-normal-type);
}

.request-cell-date,
.request-cell-author,
.request-cell-views {
  font-size: 13px;
}

.request-title {
  color: #000000;
  font-size: 15px;
  line-height: 1.6;
  font-family: var(--font-normal-type);
  word-break: break-word;
}

.request-title-row {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  align-items: flex-start;
}

.owner-delete-tag {
  display: inline-flex;
  align-items: center;
  padding: 4px 10px;
  border-radius: 999px;
  background: #fff4e8;
  color: var(--theme-color-seven);
  font-size: 12px;
  line-height: 1.3;
  font-family: var(--font-normal-type);
}

.request-row-actions {
  display: flex;
  align-items: center;
  gap: 6px;
  justify-content: flex-end;
}

.details-button,
.review-button {
  height: 36px;
  border: 0;
  border-radius: 999px;
  padding: 0 14px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  font-size: 12px;
  font-family: var(--font-bold-type);
  line-height: 1;
  white-space: nowrap;
  flex-shrink: 0;
  cursor: pointer;
  transition: transform 0.18s ease, box-shadow 0.18s ease, opacity 0.18s ease;
}

.details-button:hover,
.review-button:hover {
  transform: translateY(-1px);
}

.details-button {
  min-width: 118px;
  background: #545454;
  color: #ffffff;
  box-shadow: 0 10px 20px rgba(84, 84, 84, 0.18);
}

.review-button-approve {
  min-width: 110px;
  background: linear-gradient(180deg, #ff9f4d 0%, #f15a29 100%);
  color: #ffffff;
  box-shadow: 0 10px 20px rgba(241, 90, 41, 0.2);
}

.review-button-reject {
  min-width: 96px;
  background: linear-gradient(180deg, #6a6a6a 0%, #545454 100%);
  color: #ffffff;
  box-shadow: 0 10px 20px rgba(84, 84, 84, 0.18);
}

.empty-state {
  padding: 56px 20px;
  text-align: center;
  background: #ffffff;
  border-radius: 20px;
  color: var(--theme-color-eight);
  box-shadow: 1px 1px 30px rgba(0, 0, 0, 0.1);
}

.details-button:disabled,
.review-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

// Dialog
.review-modal {
  position: relative;
  background: #ffffff;
  border-radius: 22px;
  padding: 28px 28px 24px;
  box-shadow: 0 20px 45px rgba(0, 0, 0, 0.18);
}

.review-close-button {
  position: absolute;
  top: 18px;
  right: 18px;
  border: 0;
  background: transparent;
  cursor: pointer;
}

.review-icon-wrap {
  display: flex;
  justify-content: center;
  margin-bottom: 12px;
}

.review-title {
  text-align: center;
  font-size: 28px;
  line-height: 1.2;
  font-family: var(--font-bold-type);
  color: var(--theme-color-two);
  margin-bottom: 8px;
}

.review-subtitle {
  text-align: center;
  color: var(--theme-color-eight);
  line-height: 1.7;
  margin-bottom: 18px;
}

.review-topic-name {
  color: var(--theme-color-two);
  font-family: var(--font-bold-type);
}

.review-field-label {
  margin-bottom: 8px;
  color: var(--theme-color-two);
  font-family: var(--font-bold-type);
}

.review-reason-preview {
  padding: 14px 16px;
  border-radius: 16px;
  background: #fff8f3;
  border: 1px solid #f7d7ba;
}

.review-reason-label {
  margin-bottom: 6px;
  color: var(--theme-color-seven);
  font-size: 12px;
  font-family: var(--font-bold-type);
}

.review-reason-text {
  color: var(--theme-color-two);
  line-height: 1.7;
  white-space: pre-wrap;
}

.review-actions {
  display: flex;
  justify-content: center;
  gap: 12px;
  flex-wrap: wrap;
}

.review-action-button {
  min-width: 132px;
  border: 0;
  border-radius: 999px;
  padding: 12px 20px;
  background: #f2f2f2;
  color: var(--theme-color-two);
  font-family: var(--font-bold-type);
  cursor: pointer;
}

.review-action-reject {
  background: #fff4e8;
  color: var(--theme-color-seven);
  border: 1px solid #f6b37f;
}

.review-action-approve {
  background: linear-gradient(180deg, #ff8a4c 0%, #f15a29 100%);
  color: #ffffff;
  box-shadow: 0 8px 16px rgba(241, 90, 41, 0.18);
}

.review-action-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
</style>
